<div [class.desktop-prompt-host]="isDesktop()">
    <div class="prompt-container visible">
        <div component-host></div>
    </div>
</div>
